import { orderBy } from "lodash";
import { useContext } from "react";
import { Version } from "../models";
import { ProviderNetworkImportContext } from "../providerNetworksImportContext";
import ProviderSetService from "@app/provider-sets/providerSetService";

interface UseVersionsReturnType {
  isActivated: (versionId: number) => boolean;
  isLatestActivated: (versionId: number) => boolean;
  loadVersions: (networkId: number) => Promise<void>;
  versions: Version[];
}

export function useVersions(): UseVersionsReturnType {
  const { versions, setVersions } = useContext(ProviderNetworkImportContext);
  const providerSetService = new ProviderSetService();

  const loadVersions = async (networkId: number) => {
    const networkVersions = await providerSetService.getProviderSetVersions(networkId);

    const mappedNetworkVersions = networkVersions.map((v) => ({ activationDate: v.dateActivated ? v.dateActivated.toString() : null, createDate: v.dateCreated.toString(), id: v.providerSetVersionId }));
    const orderedVersions = orderBy(mappedNetworkVersions, (v) => v.createDate, ["desc"]);
    setVersions(orderedVersions);
  };

  const isActivated = (versionId: number): boolean => {
    const selectedVersion = versions.find((v) => v.id === versionId);
    return selectedVersion ? !!selectedVersion.activationDate : true;
  };

  const isLatestActivated = (versionId: number): boolean => {
    const selectedVersion = versions.find((v) => v.id === versionId);
    if (!selectedVersion) { return true; }
    const laterVersions = versions.find((v) => v.createDate > selectedVersion.createDate);
    return laterVersions === undefined;
  };

  return { isActivated, isLatestActivated, loadVersions, versions };
}
